import React from 'react';
import Box from 'js/components/box/box';
import Form from 'js/components/form/form';
import Panel from 'js/components/panel/panel';
import Stepper from 'js/components/stepper/stepper';
import ActivateStep from './activate-step';
import BuildContextStep from './build-context-step';
import ChooseDspStep from './choose-dsp-step';
import DetailsStep from './details-step';
import SummaryStep from './summary-step';
import steps from '../enums/steps.enum';

const Wizard = ({
    step,
    form,
    integrations,
    topics,
    termsAndConditions,
    errors,
    scaleError,
    scaleScore,
    submitting,
    validating,
    onFormChange,
    onStepChange,
    onSubmit,
    onValidate,
}) => {
    const wizardSteps = Object.values(steps)
        .filter((item) => item !== steps.SUMMARY)
        .map((item) => ({ id: item, label: item }));

    const stepIndex = Object.values(wizardSteps).findIndex(
        ({ label }) => label === step,
    );

    return (
        <Panel bordered>
            <Box padding="base">
                <Form>
                    <Box margin={[0, 0, 'large']}>
                        <Stepper
                            steps={wizardSteps}
                            currentStep={stepIndex}
                            onStepChange={(index) =>
                                onStepChange(wizardSteps[index]?.id)
                            }
                        />
                    </Box>

                    {step === steps.DETAILS && (
                        <DetailsStep
                            form={form}
                            onFormChange={onFormChange}
                            onStepChange={onStepChange}
                        />
                    )}

                    {step === steps.BUILD_CONTEXT && (
                        <BuildContextStep
                            form={form}
                            topics={topics}
                            scaleScore={scaleScore}
                            scaleError={scaleError}
                            onFormChange={onFormChange}
                            onStepChange={onStepChange}
                        />
                    )}

                    {step === steps.CHOOSE_DSP && (
                        <ChooseDspStep
                            form={form}
                            integrations={integrations}
                            errors={errors}
                            validating={validating}
                            onFormChange={onFormChange}
                            onStepChange={onStepChange}
                            onValidate={onValidate}
                        />
                    )}

                    {step === steps.ACTIVATE && (
                        <ActivateStep
                            form={form}
                            errors={errors}
                            submitting={submitting}
                            termsAndConditions={termsAndConditions}
                            onFormChange={onFormChange}
                            onStepChange={onStepChange}
                            onSubmit={onSubmit}
                        />
                    )}

                    {step === steps.SUMMARY && (
                        <SummaryStep
                            integrations={integrations}
                            onStepChange={onStepChange}
                        />
                    )}
                </Form>
            </Box>
        </Panel>
    );
};

export default Wizard;
